import Blue from "~/core";
import mapInit from "../utils/_gMapsInit";

new Blue({
	name: 'Locations Map Init',
	selector: ".locations-map",
	setup(container) {
		const mapEl = container.querySelector(".locations-map__map");
		let google;
		let map;

		if (!container.closest(".locations-listing")) {
			// FG Key: AIzaSyC9b47pSej_k-nWaimFWo-uxfrw9MpV-PI
			
			const init = async () => {
				google = await mapInit("AIzaSyC9b47pSej_k-nWaimFWo-uxfrw9MpV-PI");
				let mapOptions = {
					clickableIcons: false,
					zoom: 8,
					center: {lat: 40, lng: 40}
				}
				map = new google.maps.Map(mapEl, mapOptions);
			}
			init()
		}
	}
});

// Test key for local dev (DO NOT MERGE INTO DEV WITH THIS IN USE): AIzaSyAHe9G-GLf5nyIETswiq2h5Q0xHybCR_zk

new Blue({
	name: 'Locations Map Positioning',
	selector: ".locations-map",
	setup(container) {
		const btn = container.querySelector(".locations-map__to-top");
		let scrolling = false;

		// page overflow needs to be set to 'visible' in order for sticky map style to work
		let page = container.closest(".page");
		const breakpoint = 992;
		let currentPageWidth = page.offsetWidth;

		if (page.offsetWidth >= breakpoint) page.style.overflowX = "visible";
		else page.style.overflowX = "hidden";
		
		// page overflow needs to be hidden below lg breakpoint to prevent scrolling from mobile menu
		this.$addEvents(window, "resize", () => {
			let newPageWidth = page.offsetWidth;
			if (currentPageWidth < breakpoint && newPageWidth >= breakpoint) {
				page.style.overflowX = "visible";
			} else if (currentPageWidth >= breakpoint && newPageWidth < breakpoint) {
				page.style.overflowX = "hidden";
			}
			currentPageWidth = newPageWidth;
		});

		this.$addEvents(window, "scroll", () => {scrolling = true});

		let scrollInterval = setInterval(() => {
			if (scrolling) {
				if (container.getBoundingClientRect().top < 20) {
					btn.classList.add("showing");
				} else {
					btn.classList.remove("showing");
				}
				scrolling = false;
			}
		}, 100);

		this.$addEvents(btn, "click.prevent", () => {
			window.scroll({
				top: 0,
				behavior: "smooth"
			});
		});

	}
});

